export default {"src":"/_next/static/media/seccl_logo.47e23086.svg","height":763,"width":2638,"blurWidth":0,"blurHeight":0};